import { toast } from "react-hot-toast";

const isPdf = (f: File) => f.type === "application/pdf" || /\.pdf$/i.test(f.name);

// Form templates and redactions are created one PDF at a time. From a drop,
// take the first PDF and say so when other files were left out. `purpose`
// finishes the sentence "Drop a PDF file ...".
export function pickDroppedPdf(files: File[], purpose = "to create a form template"): File | null {
  const pdfs = files.filter(isPdf);
  if (!pdfs.length) {
    toast.error(`Drop a PDF file ${purpose}`);
    return null;
  }
  if (files.length > 1) {
    toast(`PDFs are added one at a time. Using ${pdfs[0].name}.`);
  }
  return pdfs[0];
}
